import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { Box, Typography } from "@mui/material";

const TotalRevenueLineChart = ({ data, selectedYear }) => {
  if (data.length === 0) {
    return (
      <Box sx={{ textAlign: "center", padding: "50px 0" }}>
        <Typography>No data available for this year.</Typography>
      </Box>
    );
  }

  const domain = [0, 100000];
  const ticks = [
    0, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000,
  ];

  return (
    <Box sx={{ marginLeft: "-40px" }}>
      <LineChart
        width={800}
        height={200}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid horizontal={false} strokeDasharray="1 0" />
        <XAxis
          axisLine={false}
          tickLine={false}
          tick={{
            fontSize: "11px",
            fontWeight: 400,
          }}
          dataKey="name"
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{
            fontSize: "12px",
            fontWeight: 600,
          }}
          domain={domain}
          ticks={ticks}
          tickFormatter={(value) => `$${value / 1000}k`}
        />
        <Tooltip
          content={({ payload, label }) => {
            if (!payload || payload.length === 0) return null;

            const year2024 = payload.find((p) => p.dataKey === "2024");
            const year2025 = payload.find((p) => p.dataKey === "2025");

            return (
              <Box sx={{ backgroundColor: "#673C8E0F", padding: "10px" }}>
                {year2024 && (
                  <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#683C8C" }}>
                    2024: ${(year2024.value / 1000).toFixed(2)}k
                  </Typography>
                )}
                {year2025 && (
                  <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#683C8C" }}>
                    2025: ${(year2025.value / 1000).toFixed(2)}k
                  </Typography>
                )}
              </Box>
            );
          }}
        />
        <Line
          type="monotone"
          dataKey="2024"
          stroke={
            selectedYear === "2024"
              ? "rgba(104, 60, 140, 1)"
              : "rgba(104, 60, 140, 0.35)"
          }
          strokeWidth={selectedYear === "2024" ? 3 : 1.5}
          opacity={selectedYear === "2024" ? 1 : 0.4}
        />
        <Line
          type="monotone"
          dataKey="2025"
          stroke={
            selectedYear === "2025"
              ? "rgba(104, 60, 140, 1)"
              : "rgba(104, 60, 140, 0.35)"
          }
          strokeWidth={selectedYear === "2025" ? 3 : 1.5}
          opacity={selectedYear === "2025" ? 1 : 0.4}
        />
      </LineChart>
    </Box>
  );
};

export default TotalRevenueLineChart;
